export class PetModel {
    pet_no: number
    client_no: number
    client_name: string
    pet_name: string
    weight: number
    sex: string
    dob: any
    neuter: string
    rabieDate: any
    active: string
    temperature: number
    height: number
    pet_code: string
    picture: string
    breed_name: string
    color_name: string
    specie_name: string
    breed: number
    color: number
    specie: number
    tag_no: string
    selected: boolean
    age: number
    blood_pressure: string
    rabies: string
    chip_no: string
    assigned_doctor: string
    body_score: number
    alt_breed: number 
    alt_breed_name: string
    alt_color: number 
    alt_color_name: string 
    deceased: boolean
    
    private _pet_code_array: string[]

    set pet_code_array(value: string[]) {
        this._pet_code_array = value;
    }
    get pet_code_array(): string[] {
        if (this.pet_code && this.pet_code.length > 0)
            return this.pet_code.split('');
        return [];
    }

    constructor(
        pet_no: number,
        client_no: number,
        client_name: string,
        pet_name: string,
        weight: number,
        sex: string,
        dob: any,
        neuter: string,
        rabieDate: any,
        active: string,
        temperature: number,
        height: number,
        pet_code: string,
        picture: string,
        breed_name: string,
        color_name: string,
        specie_name: string,
        breed: number,
        color: number,
        specie: number,
        tag_no: string,
        selected: boolean,
        age: number,
        blood_pressure: string,
        rabies: string,
        chip_no: string,
        assigned_doctor: string,
        body_score: number,
        alt_breed: number,
        alt_breed_name: string,
        alt_color: number,
        alt_color_name: string,
        deceased: boolean
    ) {
        this.pet_no = pet_no
        this.client_no = client_no
        this.client_name = client_name
        this.pet_name = pet_name
        this.weight = weight
        this.sex = sex
        this.dob = dob
        this.neuter = neuter
        this.rabieDate = rabieDate
        this.active = active
        this.temperature = temperature
        this.height = height
        this.pet_code = pet_code
        this.picture = picture
        this.breed_name = breed_name
        this.color_name = color_name
        this.specie_name = specie_name
        this.breed = breed
        this.color = color
        this.specie = specie
        this.tag_no = tag_no
        this.selected = selected
        this.age = age
        this.blood_pressure = blood_pressure
        this.rabies = rabies
        this.chip_no = chip_no
        this.assigned_doctor = assigned_doctor
        this.body_score = body_score
        this.alt_breed = alt_breed
        this.alt_breed_name = alt_breed_name
        this.alt_color = alt_color
        this.alt_color_name = alt_color_name
        this.deceased = deceased
    }

    code1: string
    code2: string
    code3: string
    code4: string
    codes: string[]

    // set code1(value: string) {
    //     this.code1 = value;
    // }

    // set code2(value: string) {
    //     this.code2 = value;
    // }

    // set code3(value: string) {
    //     this.code3 = value;
    // }

    // set code4(value: string) {
    //     this.code4 = value;
    // }

    // get code1(): string {
    //     let code = '';

    //     if (this.pet_code) {
    //         let split = this.pet_code.split('');
    //         if (split && split.length > 0)
    //             code = split[0];
    //     }

    //     return code;
    // }

    // get code2(): string {
    //     let code = '';

    //     if (this.pet_code) {
    //         let split = this.pet_code.split('');
    //         if (split && split.length > 1)
    //             code = split[1];
    //     }

    //     return code;
    // }

    // get code3(): string {
    //     let code = '';

    //     if (this.pet_code) {
    //         let split = this.pet_code.split('');
    //         if (split && split.length > 2)
    //             code = split[2];
    //     }

    //     return code;
    // }

    // get code4(): string {
    //     let code = '';

    //     if (this.pet_code) {
    //         let split = this.pet_code.split('');
    //         if (split && split.length > 3)
    //             code = split[3];
    //     }

    //     return code;
    // }
}